import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENPeriodType} from '../../enums';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetPeriod implements QueryProtocol {

  constructor(
    public uid: string = null,
    public name: string = null,
    public numeral: number = null,
    public type: ENPeriodType[] = null,
    public parent: SOGetPeriod = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetPeriod(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'numeral' in params ? params.numeral : null,
      'type' in params ? params.type : null,
      'parent' in params ? params.parent : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
